import { PageHeader, RegionCargando, Skeleton, Stack, TablaSkeleton } from "@/components/ui";
import { HISTORIAL_PAGE_SIZE } from "../hooks/use-historial-autorizaciones";
import { COLUMNAS_HISTORIAL_SKELETON } from "./HistorialDesktopTable";
import { HistorialResumenCard } from "./HistorialResumenCard";

/** Encabezado del historial · compartido por la página y su skeleton. */
export const ENCABEZADO_HISTORIAL_AUTORIZACIONES = {
  titulo: "Mi historial de autorizaciones",
  descripcion: "Niveles que has autorizado · ordenados por fecha más reciente.",
  breadcrumbs: [
    { label: "Inicio", href: "/dashboard" },
    { label: "Autorización", href: "/autorizacion/bandeja" },
    { label: "Historial" },
  ],
} as const;

/**
 * «Mi historial de autorizaciones» en su primera carga · MISMA forma que la
 * página (encabezado real, tarjeta de 3 indicadores y la tabla con sus 16
 * columnas reales + fila de filtros por columna; tarjetas en móvil). Es el
 * `pendingComponent` de la ruta Y la rama `isPending` de la página.
 */
export function HistorialAutorizacionesSkeleton() {
  return (
    <RegionCargando etiqueta="Cargando historial de autorizaciones…" className="w-full px-4 py-6 md:px-6">
      <PageHeader
        title={ENCABEZADO_HISTORIAL_AUTORIZACIONES.titulo}
        description={ENCABEZADO_HISTORIAL_AUTORIZACIONES.descripcion}
        breadcrumbs={[...ENCABEZADO_HISTORIAL_AUTORIZACIONES.breadcrumbs]}
        actions={<Skeleton height={36} width={36} aria-hidden="true" />}
      />
      <Stack gap="md">
        <HistorialResumenCard total={0} stats={undefined} cargando />
        <div aria-hidden="true">
          <TablaSkeleton
            columnas={COLUMNAS_HISTORIAL_SKELETON}
            filas={HISTORIAL_PAGE_SIZE}
            verticalSpacing="sm"
            conFiltrosPorColumna
            movil
          />
        </div>
      </Stack>
    </RegionCargando>
  );
}
